import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { fetchAllTypeaheadProjectsInCompany, clearTypeahed } from '../../../actions';
import MultiTypeahead from './MultiTypeahead';
import renderMultiSuggestion from '../RenderMultiSuggestion';

class ProjectsInCompanyTypeahead extends Component {
    static propTypes = {
        fetchAllTypeaheadProjectsInCompany: PropTypes.func.isRequired,
        error: PropTypes.string,
        suggestions: PropTypes.array,
        onChangeSuggestion: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        renderMultiSuggestion: PropTypes.func,
        clearTypeahed: PropTypes.func,
        animatedPlaceholder: PropTypes.bool,
        disabled: PropTypes.bool,
        isRequired: PropTypes.bool
    };

    static defaultProps = {
        suggestions: [],
        renderMultiSuggestion
    };

    state = {
        isLoading: false
    };

    onFocus = async () => {
        this.setState({ isLoading: true });

        try {
            await this.props.fetchAllTypeaheadProjectsInCompany(ProjectsInCompanyTypeahead.name);
        } finally {
            this.setState({ isLoading: false });
        }
    };

    render() {
        const { suggestions,
            value,
            animatedPlaceholder,
            onChangeSuggestion,
            clearTypeahed,
            renderMultiSuggestion,
            error,
            disabled,
            isRequired = false,
            t } = this.props;

        const options = (Array.isArray(suggestions) ? suggestions : [])
            .map(project => ({ label: project.name, value: project.id }));

        return (
            <MultiTypeahead
                options={options}
                isMulti
                isLoading={this.state.isLoading}
                value={value}
                titleId="projectsInCompany"
                animatedPlaceholder={animatedPlaceholder}
                onChangeSuggestion={onChangeSuggestion}
                handleSuggestionsClearRequested={clearTypeahed}
                onFocus={this.onFocus}
                formatOptionLabel={renderMultiSuggestion}
                error={error}
                disabled={disabled}
                required={isRequired}
                t={t}
            />
        );
    }
}

const mapStateToProps = ({ typeahead }) => ({
    suggestions:
        typeahead.source === ProjectsInCompanyTypeahead.name
            ? typeahead.list
            : ProjectsInCompanyTypeahead.defaultProps.suggestions
});

export default connect(mapStateToProps, {
    fetchAllTypeaheadProjectsInCompany,
    clearTypeahed
})(ProjectsInCompanyTypeahead);
